import { render } from "./mfa-steps.vue?vue&type=template&id=0007d74d&scoped=true"
import script from "./mfa-steps.vue?vue&type=script&lang=js"
export * from "./mfa-steps.vue?vue&type=script&lang=js"

import "../resources/css/settings.scss?vue&type=style&index=0&id=0007d74d&lang=scss&scoped=true&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0007d74d"]])

export default __exports__